<div class="sidebar-overlay" [class.is-open]="isVisible$ | async" (click)="closeSidebar()"></div>
<aside class="sidebar" [class.is-open]="isVisible$ | async">
  <div class="sidebar-header">
    <div class="sidebar-header-content">
      <h3 class="sidebar-title">{{ 'sidebar.title' | translate }}</h3>
      <p class="sidebar-description">{{ 'sidebar.description' | translate }}</p>
    </div>
  </div>
  <nav class="sidebar-nav">
    <ul>
      @for (item of menuItems$ | async; track item) {
        <li>
          @if (!item.children || item.children.length === 0) {
            <a (click)="onMenuClick(item.action)">
              <i [class]="'pi ' + item.icon"></i>
              <span>{{ item.name }}</span>
            </a>
          }
          @if (item.children && item.children.length > 0) {
            <a (click)="toggleSubmenu(item)"
              [class.expanded]="item.expanded">
              <i [class]="'pi ' + item.icon"></i>
              <span>{{ item.name }}</span>
              <i class="pi pi-chevron-down expand-icon"></i>
            </a>
          }
          @if (item.children && item.children.length > 0) {
            <ul class="submenu" [class.is-open]="item.expanded">
              @for (child of item.children; track child) {
                <li>
                  <a (click)="onMenuClick(child.action)">
                    <i [class]="'pi ' + child.icon"></i>
                    <span>{{ child.name }}</span>
                  </a>
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
  </nav>

  <!-- Perfil del usuario en la parte inferior -->
  @if (userProfile$ | async; as userProfile) {
    <div class="sidebar-profile">
      <!-- Menú de opciones del perfil (ahora arriba) -->
      <div class="profile-menu" [class.show]="showProfileMenu">
        <ul>
          <li>
            <a (click)="goToProfile()">
              <i class="pi pi-user"></i>
              <span>{{ 'common.profile' | translate }}</span>
            </a>
          </li>
          <li>
            <a (click)="logout()">
              <i class="pi pi-sign-out"></i>
              <span>{{ 'common.logout' | translate }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="profile-card" (click)="toggleProfileMenu()">
        <div class="profile-image">
          <img [src]="userProfile.urlProfileImage || 'assets/images/default-profile.png'" [alt]="userProfile.fullName"
            class="profile-photo">
          </div>
          <div class="profile-info">
            <h4 class="profile-name">{{ userProfile.fullName }}</h4>
            <p class="profile-email">{{ userProfile.mainEmail }}</p>
          </div>
          <div class="profile-arrow">
            <i class="pi pi-chevron-up" [class.rotated]="showProfileMenu"></i>
          </div>
        </div>
      </div>
    }
  </aside>